import {DOCUMENT_SYNC_STATUS} from "../constants";

const getPrettySyncStatus = (status) => DOCUMENT_SYNC_STATUS[status]?.textValue || status;

export default getPrettySyncStatus;
